import { useDispatch, useSelector } from 'react-redux'
import { coreApi } from '../../../services/api'
import { RootState } from '../../../store/modules/rootReducer'
import { useEffect } from 'react'
import { PreferencesRequest } from '../../../store/modules/dashboard/action'

export const fetcher = (url: string) => coreApi.get(url).then((res) => res.data)

export const useGetPreferences = () => {
  const dispatch = useDispatch()

  const { student, token, preferences } = useSelector((state: RootState) => ({
    student: state.student,
    token: state.auth.token,
    preferences: state.dashboard.preferences,
  }))

  useEffect(() => {
    if (
      token &&
      student.profile._id &&
      preferences.loading === false &&
      preferences.fetched === false
    ) {
      dispatch(PreferencesRequest())
    }
  }, [student, token, preferences.fetched, preferences.loading, dispatch])

  return preferences
}
